export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_08.89cc9eb2.jpg";